export const POST_WALK_THRU_REQUEST = 'user.investor.POST_WALK_THRU_REQUEST'
export const POST_WALK_THRU_SUCCESS = 'user.investor.POST_WALK_THRU_SUCCESS'
export const POST_WALK_THRU_FAILURE = 'user.investor.POST_WALK_THRU_FAILURE'
